// Load Async Scripts
function loadScript(src) {
    return new Promise(function (resolve, reject) {
        var s;
        s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });
}




jQuery(document).on('ready', () => {
    BASE.bp = 768;
    BASE.onReady();
    BASE.onResize();
});

var BASE = {
    onReady: () => {

        BASE.placeLangNav();
        BASE.setMinHeight();

        setTimeout( function() {
            BASE.resizeViewport()
        }, 500);

        console.log('Hello ROUTEX');
        
        jQuery(".navbar-burger").click(function() {
              jQuery(".navbar-burger").toggleClass("is-active");
              jQuery("#primary-menu").fadeToggle("is-active");
          });
    },



    onResize: () => {
        jQuery(window).on('resize orientationChange', () => {
            BASE.placeLangNav();
            BASE.setMinHeight();
            BASE.resizeViewport();
        });
    },



    placeLangNav: () => {
        if ( jQuery('body').width() <= BASE.bp ) {
            if ( jQuery('#primary-menu .select-language').length < 1 )
                jQuery('.navbar-menu-wrapper').append(jQuery('.select-language'));
        
        } else {
            if ( jQuery('.navbar-brand .select-language').length < 1 )
                jQuery('.navbar-burger').before(jQuery('.select-language'));

        }
    },



    setMinHeight: () => {
        var headerHeight    = jQuery('nav.navbar').outerHeight();
        var footerHeight    = jQuery('footer.footer').outerHeight();
        var adminHeight     = ( jQuery('#wpadminbar').length >= 1 ) ? jQuery('#wpadminbar').outerHeight() : 0;

        var exclHeight = headerHeight + footerHeight + adminHeight;
        
        jQuery('main .container.main').css('min-height', 'calc(100vh - ' + exclHeight + 'px)');
    },



    resizeViewport: () => {
      let vh = window.innerHeight * 0.01;
      let vhString = vh + 'px';

      let isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent)
      if (!isIEOrEdge) {
        document.documentElement.style.setProperty('--vh', vhString);
      }
    }
};





// (function($) {
//   $('body').addClass('js');

//   /* Menu burger */
//   $('.navbar-burger').click(function(event) {
//     event.preventDefault();

//     var $this = $(this);
//     var id = $this.data('target');
//     var $target = $('#' + id);

//     if ( $target.length > 0 ) {
//       $this.toggleClass('is-active');
//       $target.toggleClass('is-active');
//     }
//   });
// })(jQuery)
